// extracted by mini-css-extract-plugin
module.exports = {"CheckoutSummary":"CheckoutSummary_CheckoutSummary__3ED15"};